<template>
  <div id="neighbourhood">
    <v-card flat class="elevation-0 transparent blue-text green-background pb-2">
      <v-card-title primary-title class="layout justify-center pt-3 pb-0">
        <div class="headline text-xs-center">Your neighbourhood</div>
      </v-card-title>
      <v-card-text class="justify-center text-xs-center">
        See how many of your neighbours have answered the questions. Enter your address below to view your neighbourhood.
      </v-card-text>
      <!--
      <v-layout align-center justify-center row fill-height>
        <v-btn
          class="blue-text yellow-background"
          dark
          large
          round
          @click="$vuetify.goTo('#map', {})"
        >View your neighbourhood</v-btn>
      </v-layout>
      -->
    </v-card>

    <section>
      <div class="green-background">
        <v-layout>
          <v-flex xs10 offset-xs1 mb-5>
            <div id="map"></div>
            <input
              id="pac-input"
              class="controls ml-5 mr-6"
              type="text"
              :placeholder="$vuetify.breakpoint.mdAndUp ? 'Enter your address to view your neighbourhood' : 'Enter your address'"
            >
          </v-flex>
        </v-layout>
      </div>
    </section>
  </div>
</template>

<style>
@import "../assets/styles/styles.css";
</style>

<script>
import MarkerClusterer from "@google/markerclusterer";
import gmapsInit from "../utils/gmaps";
import { counts } from "../utils/counts";

export default {
  async mounted() {
    // console.log('Neighbourhood.mounted');
    try {
      const google = await gmapsInit();
      const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 5,
        center: { lat: -20.0, lng: 143.0 }
      });

      let searchBox = new google.maps.places.SearchBox(
        document.getElementById("pac-input")
      );
      map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(
        document.getElementById("pac-input")
      );

      map.addListener("bounds_changed", function() {
        searchBox.setBounds(map.getBounds());
        //console.log('searchBox=>' + searchBox.getBounds())
      });

      let markers = [];

      counts.forEach(function(postcode) {
        if (postcode.count)
          for (let i = 0; i < postcode.count; i++) {
            markers.push(
              new google.maps.Marker({
                position: { lat: postcode.lat, lng: postcode.lng },
                label: ""
              })
            );
          }
      });

      new MarkerClusterer(map, markers, {
        imagePath: "https://marker-clusterer-vpcygagalx.now.sh/m"
      });

      searchBox.addListener("places_changed", function() {
        let places = searchBox.getPlaces();
        if (places.length == 0) return;
        // Clear out the old markers.
        markers.forEach(function(marker1) {
          marker1.setMap(null);
        });
        // For each place, get the icon, name and location.
        let bounds = new google.maps.LatLngBounds();
        places.forEach(function(place) {
          if (!place.geometry) {
            //console.log("Returned place contains no geometry");
            return;
          }
          /* Excluded 12-Jun-2020
          let icon = {
            url: place.icon,
            size: new google.maps.Size(71, 71),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(17, 34),
            scaledSize: new google.maps.Size(25, 25)
          };
          */
          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        map.fitBounds(bounds);
        map.setZoom(10);
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
};
</script>